// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Access Management page header (extends ecr-ops-page-header with actions) ── */
.am-page-header {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
}

.am-page-header__text {
  min-width: 0;
}

.am-page-header__actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  padding-bottom: 2px;
}

/* ── Sub-nav tabs for the 3 Access Management screens ── */
.am-subnav {
  display: flex;
  gap: 4px;
  padding: 0 36px;
  background: #1a1a1a;
  border-bottom: 3px solid #86BC25;
}

.am-subnav__link {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 10px 14px;
  font-size: 13px;
  font-weight: 600;
  color: #9ca3af;
  text-decoration: none;
  border-bottom: 2px solid transparent;
  transition: color 0.15s ease, border-color 0.15s ease;
}

.am-subnav__link:hover {
  color: #fff;
}

.am-subnav__link.active {
  color: #fff;
  border-bottom-color: #86BC25;
}

/* ── Secondary sub-nav (e.g. Users/Roles views within a screen) — lighter,
   sits directly under a page header rather than the dark ecr-ops shell bar ── */
.am-subnav--secondary {
  background: #fff;
  border-bottom: 1px solid #DCE3EA;
  padding: 0 36px;
}

.am-subnav--secondary .am-subnav__link {
  background: transparent;
  border: none;
  border-bottom: 2px solid transparent;
  color: #6b7280;
  font-family: inherit;
  cursor: pointer;
}

.am-subnav--secondary .am-subnav__link:hover {
  color: #111827;
}

.am-subnav--secondary .am-subnav__link.active {
  color: #111827;
  border-bottom-color: #86BC25;
}

/* ── Shared filter/toolbar row ── */
.am-toolbar {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  padding: 14px 0;
}

.am-toolbar__note {
  font-size: 12px;
  color: #9ca3af;
  font-style: italic;
}

.am-grid-wrap {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-top: 3px solid #86BC25;
  border-radius: 10px;
  overflow: hidden;
}

.am-grid-wrap .MuiDataGrid-footerContainer {
  display: none;
}

/*
 * modalTOS.css (TOS modal) styles .MuiDataGrid-* globally with !important
 * (box-shadow, min-height, border-radius, margin-bottom per row, and
 * .MuiDataGrid-virtualScrollerContent { height: unset !important }, which
 * breaks autoHeight mode entirely — these grids use a fixed-height wrapper
 * instead for that reason). These rules neutralize the remaining visual leaks
 * for this grid only, matching the counter-rules EcrOpsOrgManagement.css uses.
 */
.am-grid-wrap .MuiDataGrid-virtualScrollerContent {
  height: auto !important;
}

.am-grid-wrap .MuiDataGrid-root .MuiDataGrid-row {
  box-shadow: none !important;
  border-radius: 0 !important;
  margin-bottom: 0 !important;
  min-height: 56px !important;
}

.am-grid-wrap
  .MuiDataGrid-root
  .MuiDataGrid-row:not(.MuiDataGrid-row--dynamicHeight)
  > .MuiDataGrid-cell {
  min-height: 56px !important;
  display: flex;
  align-items: center;
}

@media (max-width: 900px) {
  .am-page-header {
    align-items: flex-start;
    flex-direction: column;
  }

  .am-subnav {
    padding: 0 16px;
    overflow-x: auto;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/ecrOps/accessManagement/AccessManagementLayout.css"],"names":[],"mappings":"AAAA,mFAAmF;AACnF;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,mBAAmB;AACrB;;AAEA,2DAA2D;AAC3D;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,oCAAoC;EACpC,qDAAqD;AACvD;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,4BAA4B;AAC9B;;AAEA;gFACgF;AAChF;EACE,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,oCAAoC;EACpC,cAAc;EACd,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;;;;;;;EAOE;AACF;EACE,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;;;;EAIE,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE;IACE,uBAAuB;IACvB,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;AACF","sourcesContent":["/* ── Access Management page header (extends ecr-ops-page-header with actions) ── */\n.am-page-header {\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.am-page-header__text {\n  min-width: 0;\n}\n\n.am-page-header__actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n  padding-bottom: 2px;\n}\n\n/* ── Sub-nav tabs for the 3 Access Management screens ── */\n.am-subnav {\n  display: flex;\n  gap: 4px;\n  padding: 0 36px;\n  background: #1a1a1a;\n  border-bottom: 3px solid #86BC25;\n}\n\n.am-subnav__link {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 10px 14px;\n  font-size: 13px;\n  font-weight: 600;\n  color: #9ca3af;\n  text-decoration: none;\n  border-bottom: 2px solid transparent;\n  transition: color 0.15s ease, border-color 0.15s ease;\n}\n\n.am-subnav__link:hover {\n  color: #fff;\n}\n\n.am-subnav__link.active {\n  color: #fff;\n  border-bottom-color: #86BC25;\n}\n\n/* ── Secondary sub-nav (e.g. Users/Roles views within a screen) — lighter,\n   sits directly under a page header rather than the dark ecr-ops shell bar ── */\n.am-subnav--secondary {\n  background: #fff;\n  border-bottom: 1px solid #DCE3EA;\n  padding: 0 36px;\n}\n\n.am-subnav--secondary .am-subnav__link {\n  background: transparent;\n  border: none;\n  border-bottom: 2px solid transparent;\n  color: #6b7280;\n  font-family: inherit;\n  cursor: pointer;\n}\n\n.am-subnav--secondary .am-subnav__link:hover {\n  color: #111827;\n}\n\n.am-subnav--secondary .am-subnav__link.active {\n  color: #111827;\n  border-bottom-color: #86BC25;\n}\n\n/* ── Shared filter/toolbar row ── */\n.am-toolbar {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n  padding: 14px 0;\n}\n\n.am-toolbar__note {\n  font-size: 12px;\n  color: #9ca3af;\n  font-style: italic;\n}\n\n.am-grid-wrap {\n  background: #fff;\n  border: 1px solid #e5e7eb;\n  border-top: 3px solid #86BC25;\n  border-radius: 10px;\n  overflow: hidden;\n}\n\n.am-grid-wrap .MuiDataGrid-footerContainer {\n  display: none;\n}\n\n/*\n * modalTOS.css (TOS modal) styles .MuiDataGrid-* globally with !important\n * (box-shadow, min-height, border-radius, margin-bottom per row, and\n * .MuiDataGrid-virtualScrollerContent { height: unset !important }, which\n * breaks autoHeight mode entirely — these grids use a fixed-height wrapper\n * instead for that reason). These rules neutralize the remaining visual leaks\n * for this grid only, matching the counter-rules EcrOpsOrgManagement.css uses.\n */\n.am-grid-wrap .MuiDataGrid-virtualScrollerContent {\n  height: auto !important;\n}\n\n.am-grid-wrap .MuiDataGrid-root .MuiDataGrid-row {\n  box-shadow: none !important;\n  border-radius: 0 !important;\n  margin-bottom: 0 !important;\n  min-height: 56px !important;\n}\n\n.am-grid-wrap\n  .MuiDataGrid-root\n  .MuiDataGrid-row:not(.MuiDataGrid-row--dynamicHeight)\n  > .MuiDataGrid-cell {\n  min-height: 56px !important;\n  display: flex;\n  align-items: center;\n}\n\n@media (max-width: 900px) {\n  .am-page-header {\n    align-items: flex-start;\n    flex-direction: column;\n  }\n\n  .am-subnav {\n    padding: 0 16px;\n    overflow-x: auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
